import { PublicSharedProduct } from '../types/productShare';



export interface PublicSharedProductConfigInput {

  readonly productCode?: string;

  readonly productName: string;

  readonly productCallType: 'autocall' | 'callable' | 'not-callable';

  readonly productTypeName?: string;

  readonly barrierLevel: number | null;

  readonly strikeLevel: number | null;

  readonly underlyings?: PublicSharedProduct['underlyings'];

}



export interface PublicSharedChartProduct {
  readonly name: string;
  readonly isin: string;
  readonly bid: number;
  readonly issuePrice: number | null;
  readonly productCode: string | null;
  readonly premiumPct: number | null;
  readonly barrierLevel: number | null;
  readonly strikeLevel: number | null;
}



export const mapPublicSharedProductForConfig = (

  product: PublicSharedProduct

): PublicSharedProductConfigInput => {

  const { indicators } = product;



  return {

    productCode: product.productCode ?? undefined,

    productName: product.name,

    productCallType: product.productCallType,

    productTypeName: indicators.productTypeName ?? undefined,

    barrierLevel: indicators.barrierLevel,

    strikeLevel: indicators.strikeLevel,

    underlyings: product.underlyings,

  };

};



export const mapPublicSharedChartProduct = (

  product: PublicSharedProduct

): PublicSharedChartProduct => ({
  name: product.name,
  isin: product.isin,
  bid: product.bid,
  issuePrice: product.indicators.issuePrice,
  productCode: product.productCode,
  premiumPct: product.indicators.premiumPct,
  barrierLevel: product.indicators.barrierLevel,
  strikeLevel: product.indicators.strikeLevel,
});



export const formatSharedUnderlyingsText = (underlyings: PublicSharedProduct['underlyings']): string => {

  if (!underlyings.length) {

    return '-';

  }



  const seen = new Set<string>();

  const names = underlyings

    .filter((underlying) => {

      const key = underlying.isin || underlying.name || '';

      if (!key || seen.has(key)) {

        return false;

      }

      seen.add(key);

      return true;

    })

    .map((underlying) => underlying.name);



  return names.length ? names.join(', ') : '-';

};



const parseNumericIndicator = (value: string | number | null | undefined): number | null => {

  if (value === null || value === undefined || value === '') {

    return null;

  }



  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;

};



export const getSharedBasketTypeUp = (

  indicators: PublicSharedProduct['indicators']

): number => parseNumericIndicator(indicators.basketTypeUp) ?? 0;



export const getSharedUpside = (

  indicators: PublicSharedProduct['indicators']

): number | null => parseNumericIndicator(indicators.upside);



export const getSharedDownside = (

  indicators: PublicSharedProduct['indicators']

): number | null => parseNumericIndicator(indicators.downside);


